export default "__VITE_ASSET__BlDJTGW7__"